import { ClockIcon } from '@synoptic/ui-kit/icons/react/clock.js';
import { EditPencilIcon } from '@synoptic/ui-kit/icons/react/edit-pencil.js';
import { GraphUpIcon } from '@synoptic/ui-kit/icons/react/graph-up.js';
import { SearchEngineIcon } from '@synoptic/ui-kit/icons/react/search-engine.js';
import { TrophyIcon } from '@synoptic/ui-kit/icons/react/trophy.js';
import { TournamentState } from '@/__generated__/graphql';
import { diffInDays } from '@/date-utils/diff-in-days';

const StateGroup = {
  active: 'active',
  closed: 'closed',
  ended: 'ended',
} as const;

export const getTournamentStateGroup = (state?: TournamentState) => {
  switch (state) {
    case TournamentState.Active:
      return StateGroup.active;
    case TournamentState.Processing:
    case TournamentState.Preliminary:
      return StateGroup.closed;
    case TournamentState.Final:
      return StateGroup.ended;
    default:
      return;
  }
};

export const getStateStat = (
  state: TournamentState,
  deadline?: string | null,
) => {
  switch (state) {
    case TournamentState.Draft:
      return {
        icon: <EditPencilIcon />,
        label: 'Draft',
      };
    case TournamentState.Active:
      return deadline
        ? {
            icon: <ClockIcon />,
            label: diffInDays(new Date(), new Date(deadline)) + ' days left',
          }
        : null;
    case TournamentState.Processing:
      return {
        icon: <SearchEngineIcon />,
        label: 'Processing results',
      };
    case TournamentState.Preliminary:
      return {
        icon: <GraphUpIcon />,
        label: 'Preliminary results',
      };
    case TournamentState.Final:
      return {
        icon: <TrophyIcon />,
        label: 'Final results',
      };
    default:
      return null;
  }
};
